<app-page>
  <trade-creator></trade-creator>
</app-page>
